import { useReactFlow } from '@xyflow/react';
import { useKeyboardShortcut } from '@/features/canvas/engine/hooks/use-keyboard-shortcut';

const ARROW_KEYS = ['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'] as const;

const DELTAS: Record<string, [number, number]> = {
  ArrowRight: [1, 0],
  ArrowLeft:  [-1, 0],
  ArrowDown:  [0, 1],
  ArrowUp:    [0, -1],
};

export function useNudgeShortcut(onNudge: (ids: string[], dx: number, dy: number) => void) {
  const { getNodes } = useReactFlow();
  useKeyboardShortcut(
    { keys: ARROW_KEYS },
    (e) => {
      const selected = getNodes().filter((n) => n.selected).map((n) => n.id);
      if (selected.length === 0) return;
      e.preventDefault();
      const step = e.shiftKey ? 10 : 1;
      const [dx, dy] = DELTAS[e.key];
      onNudge(selected, dx * step, dy * step);
    },
  );
}
